"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionItemImpressionTrack = exports.CollectionImpressionTrack = exports.ViewState = void 0;
const common_snap_ad_impression_track_1 = require("./common_snap_ad_impression_track");
const collection_interaction_track_1 = require("./collection_interaction_track");
const remote_webpage_impression_track_1 = require("./remote_webpage_impression_track");
const deep_link_impression_track_1 = require("./deep_link_impression_track");
const showcase_impression_track_1 = require("./showcase_impression_track");
const app_install_impression_track_1 = require("./app_install_impression_track");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
/** Indicates the tile interacted or not */
var ViewState;
(function (ViewState) {
    /** VIEW_STATE_UNSET - Not set */
    ViewState[ViewState["VIEW_STATE_UNSET"] = 0] = "VIEW_STATE_UNSET";
    /** INTERACTED - User viewed the tile and tapped the tile */
    ViewState[ViewState["INTERACTED"] = 1] = "INTERACTED";
    /** VIEWED - User only viewed the tile but not tapped the tile */
    ViewState[ViewState["VIEWED"] = 2] = "VIEWED";
    /**
     * NOT_VIEWED - For future proof, the collection ad can be a carousel, some tiles are hidden.
     * those products are not viewed by users.
     */
    ViewState[ViewState["NOT_VIEWED"] = 3] = "NOT_VIEWED";
    ViewState[ViewState["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ViewState = exports.ViewState || (exports.ViewState = {}));
function createBaseCollectionImpressionTrack() {
    return {
        topsnapImpression: undefined,
        collectionItemsTrack: [],
        collectionInteractionsTrack: [],
    };
}
exports.CollectionImpressionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.topsnapImpression !== undefined) {
            common_snap_ad_impression_track_1.CommonSnapAdImpressionTrack.encode(message.topsnapImpression, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.collectionItemsTrack) {
            exports.CollectionItemImpressionTrack.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.collectionInteractionsTrack) {
            collection_interaction_track_1.CollectionInteractionTrack.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCollectionImpressionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.topsnapImpression = common_snap_ad_impression_track_1.CommonSnapAdImpressionTrack.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.collectionItemsTrack.push(exports.CollectionItemImpressionTrack.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.collectionInteractionsTrack.push(collection_interaction_track_1.CollectionInteractionTrack.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseCollectionImpressionTrack();
        message.topsnapImpression =
            object.topsnapImpression !== undefined &&
                object.topsnapImpression !== null
                ? common_snap_ad_impression_track_1.CommonSnapAdImpressionTrack.fromPartial(object.topsnapImpression)
                : undefined;
        message.collectionItemsTrack =
            object.collectionItemsTrack?.map((e) => exports.CollectionItemImpressionTrack.fromPartial(e)) || [];
        message.collectionInteractionsTrack =
            object.collectionInteractionsTrack?.map((e) => collection_interaction_track_1.CollectionInteractionTrack.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCollectionItemImpressionTrack() {
    return {
        productId: undefined,
        positionIndex: undefined,
        attachmentType: 0,
        typedTrackData: undefined,
        viewState: 0,
    };
}
exports.CollectionItemImpressionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.productId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.productId }, writer.uint32(10).fork()).ldelim();
        }
        if (message.positionIndex !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.positionIndex }, writer.uint32(18).fork()).ldelim();
        }
        if (message.attachmentType !== 0) {
            writer.uint32(24).int32(message.attachmentType);
        }
        if (message.typedTrackData?.$case === "remoteWebpage") {
            remote_webpage_impression_track_1.RemoteWebpageImpressionTrack.encode(message.typedTrackData.remoteWebpage, writer.uint32(34).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "deepLink") {
            deep_link_impression_track_1.DeepLinkImpressionTrack.encode(message.typedTrackData.deepLink, writer.uint32(42).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "showcase") {
            showcase_impression_track_1.ShowcaseImpressionTrack.encode(message.typedTrackData.showcase, writer.uint32(50).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "appInstall") {
            app_install_impression_track_1.AppInstallImpressionTrack.encode(message.typedTrackData.appInstall, writer.uint32(58).fork()).ldelim();
        }
        if (message.viewState !== 0) {
            writer.uint32(64).int32(message.viewState);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCollectionItemImpressionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.productId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.positionIndex = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.attachmentType = reader.int32();
                    break;
                case 4:
                    message.typedTrackData = {
                        $case: "remoteWebpage",
                        remoteWebpage: remote_webpage_impression_track_1.RemoteWebpageImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 5:
                    message.typedTrackData = {
                        $case: "deepLink",
                        deepLink: deep_link_impression_track_1.DeepLinkImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 6:
                    message.typedTrackData = {
                        $case: "showcase",
                        showcase: showcase_impression_track_1.ShowcaseImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 7:
                    message.typedTrackData = {
                        $case: "appInstall",
                        appInstall: app_install_impression_track_1.AppInstallImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 8:
                    message.viewState = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseCollectionItemImpressionTrack();
        message.productId = object.productId ?? undefined;
        message.positionIndex = object.positionIndex ?? undefined;
        message.attachmentType = object.attachmentType ?? 0;
        if (object.typedTrackData?.$case === "remoteWebpage" &&
            object.typedTrackData?.remoteWebpage !== undefined &&
            object.typedTrackData?.remoteWebpage !== null) {
            message.typedTrackData = {
                $case: "remoteWebpage",
                remoteWebpage: remote_webpage_impression_track_1.RemoteWebpageImpressionTrack.fromPartial(object.typedTrackData.remoteWebpage),
            };
        }
        if (object.typedTrackData?.$case === "deepLink" &&
            object.typedTrackData?.deepLink !== undefined &&
            object.typedTrackData?.deepLink !== null) {
            message.typedTrackData = {
                $case: "deepLink",
                deepLink: deep_link_impression_track_1.DeepLinkImpressionTrack.fromPartial(object.typedTrackData.deepLink),
            };
        }
        if (object.typedTrackData?.$case === "showcase" &&
            object.typedTrackData?.showcase !== undefined &&
            object.typedTrackData?.showcase !== null) {
            message.typedTrackData = {
                $case: "showcase",
                showcase: showcase_impression_track_1.ShowcaseImpressionTrack.fromPartial(object.typedTrackData.showcase),
            };
        }
        if (object.typedTrackData?.$case === "appInstall" &&
            object.typedTrackData?.appInstall !== undefined &&
            object.typedTrackData?.appInstall !== null) {
            message.typedTrackData = {
                $case: "appInstall",
                appInstall: app_install_impression_track_1.AppInstallImpressionTrack.fromPartial(object.typedTrackData.appInstall),
            };
        }
        message.viewState = object.viewState ?? 0;
        return message;
    },
};
//# sourceMappingURL=collection_impression_track.js.map